export { default } from './NonGuestShoppingMessage'
